// ContraindicationsDialog.jsx (controlled)
import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogBody,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';
import { Checkbox } from '@/components/ui/checkbox';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Info, AlertCircle } from 'lucide-react';

export default function TimeslotReservationErrorDialog({
  open,
  onOpenChange,
  onAccept,
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        onOpenChange(isOpen); // bubble to parent
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Dėmesio!</DialogTitle>
        </DialogHeader>
        <DialogBody className="space-y-6 max-h-[75dvh] overflow-y-auto">
          <div className="space-y-4 text-center">
            Įvyko klaida rezervuojant laiką. Prašome pabandyti vėliau arba
            pasirinkti kitą laiką.
          </div>
        </DialogBody>

        <DialogFooter>
          <Button
            variant="secondary"
            onClick={() => {
              onOpenChange(false);
            }}
          >
            Gerai
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
